export const titleCase = (k) =>
  (k || "").replaceAll("_", " ").replace(/\b\w/g, (c) => c.toUpperCase())
